export default [
  {
    id: `material`,
    title: `Качество материала`,
    content: {
      description: `<h3>Чехол для iPhone 7 Plus с печатью на всей поверхности</h3><p>Чехол для iPhone 7 Plus сделан из прочного и тонкого пластика. Чехол не царапается, а краски сохраняют яркость спустя даже долгое время. Поверхность чехла покрыта блестящим ламинированием, что придает рисунку потрясающую насыщенность. Рисунок наносится на всю поверхность, включая боковые поверхности.</p><p>Материалы:<br>Пластик с глянцевым покрытием.</p><p>Размеры:<br>160х80 мм.</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `<p>Рисунок наносится непосредственно на чехол и запекается при очень высокой температуре в специальной печи. Для нанесения рисунка используется уникальное для России запатентованное оборудование и расходные материалы, которые позволяют запечатать весь чехол, включая боковые стороны.</p>`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
